import { For, Show, createMemo } from "solid-js";
import type { JSX } from "solid-js/h/jsx-runtime";
import { TranslationField } from "~/components/TranslationField";
import { Tabs, TabsList, TabsTrigger } from "~/components/ui/tabs";
import { cn } from "~/util/utils";
import { useDateWidget } from "../../../providers/dates/context";

export function CategoryPicker(props: Pick<JSX.HTMLAttributes<HTMLElement>, "class">) {
	const { categories, category, setCategory } = useDateWidget();

	const tabs = createMemo(() => {
		const _categories = categories();

		if (_categories.length <= 1) {
			const category = _categories.at(0);
			return !category ? [] : [category];
		}

		return _categories;
	});

	const onMountTabsList: JSX.HTMLAttributes<HTMLDivElement>["ref"] = (el) =>
		setTimeout(() => {
			if (!el) return;

			const observer = new ResizeObserver(() => {
				// Set a css variable to the width of the tabs list to allow for overflow scrolling
				el.style.setProperty("--tabs-list-width", `${el.offsetWidth}px`);
			});

			observer.observe(window.document.body);
		});

	return (
		<Tabs
			class={cn("w-full max-w-full overflow-x-auto h-12 lg:h-auto", props.class)}
			value={category()}
			onChange={setCategory}
		>
			<TabsList
				ref={onMountTabsList}
				class="gap-x-3 justify-normal lg:flex"
			>
				<Show when={tabs().length > 1}>
					<TabsTrigger
						class="rounded-full flex-1"
						value=""
						variant="filled"
					>
						Alles
					</TabsTrigger>
				</Show>
				<For each={tabs()}>
					{(cat) => {
						const rgbValues = {
							r: Number.parseInt(cat.color.slice(1, 3), 16),
							g: Number.parseInt(cat.color.slice(3, 5), 16),
							b: Number.parseInt(cat.color.slice(5, 7), 16),
						};

						return (
							<TabsTrigger
								class="rounded-full flex-1 text-[var(--selected-bg-color)] data-[selected]:text-white bg-[var(--bg-color)] data-[selected]:bg-[var(--selected-bg-color)]"
								value={cat.id}
								variant="filled"
								style={{
									"--bg-color": `rgba(${rgbValues.r}, ${rgbValues.g}, ${rgbValues.b}, 0.07)`,
									"--selected-bg-color": cat.color,
								}}
							>
								<TranslationField key={cat.title} />
							</TabsTrigger>
						);
					}}
				</For>
			</TabsList>
		</Tabs>
	);
}
